module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_8.0177f1ef.png";